// Extend window interface
declare global {
	interface Window {
		__OPTIONS__: {
			currency: string;
			locale: string;
			identifier: string;
			loyalty_system_options: {
				currency_exponent: number;
				player_id: string;
			};
			drops_websocket_url: string;
			lobby_options?: {
				show_lobby?: boolean;
			};
			drops_options?: {
				token: string;
				url: string;
				fe_script_url: string;
			};
			rules: {
				currency: {
					subunits: number;
					code: string;
					symbol: string;
				};
			};
		};
	}
}

interface Options {
	identifier: string;
	currency: string;
	locale: string;
	exponent: number;
	userId: string;
	wsUrl: string;
	token: string;
	url: string;
	rules: {
		currency: {
			subunits: number;
			code: string;
			symbol: string;
		};
	};
	fe_script_url: string;
}

export const options: Options = {
	currency: '',
	identifier: '',
	locale: '',
	exponent: 2,
	userId: '',
	wsUrl: '',
	token: '',
	url: '',
	rules: {
		currency: {
			subunits: 0,
			code: '',
			symbol: ''
		}
	},
	fe_script_url: ''
};

export const readOptions = () => {
	let currencyAlias = window.__OPTIONS__.currency;
	if (currencyAlias === 'LYSC') {
		currencyAlias = 'SC';
	}

	options.token =
		'eyJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJnYW1lcy10ZXN0LWRhdGEtaHViMSIsInBsYXllcl9pZCI6MTEyODI4OCwicGxheWVyX2Nhc2lub19pZCI6ImFlMWEwYWJjNy0wZGMxLTQ0ZGEtYjE3Ny1hZWI1Yjk5ZGRiOWYtVVNEIiwic2VydmVyX2lkIjoiZGV2ZGVtbyIsImN1cnJlbmN5IjoiVVNEIiwiYnJhbmRfbmFtZSI6ImRldmRlbW8ifQ.20dEuKDXFVoeUTDlDDMPuQvyp5vLIATTuqS48LMYdB0';
	options.url = 'https://loyalty-drops.k3s-dev.bgaming-system.com/api/v1';
	options.currency = currencyAlias;
	options.locale = window.__OPTIONS__.locale;
	options.identifier = window.__OPTIONS__.identifier;
	options.exponent = window.__OPTIONS__.loyalty_system_options.currency_exponent;
	options.userId = window.__OPTIONS__.loyalty_system_options.player_id;
	options.wsUrl = window.__OPTIONS__.drops_websocket_url;
	options.token = window.__OPTIONS__?.drops_options?.token || '';
	options.url = window.__OPTIONS__?.drops_options?.url || '';
	options.fe_script_url = window.__OPTIONS__?.drops_options?.fe_script_url || '';
	options.rules = window.__OPTIONS__?.rules;
	// options.rules.currency.subunits = window.__OPTIONS__?.rules?.currency?.subunits
	// 	? Math.floor(Math.log10(window.__OPTIONS__?.rules?.currency?.subunits))
	// 	: 0;
	//APP_STORE?.rules?.currency?.subunits ? Math.floor(Math.log10(APP_STORE?.rules?.currency?.subunits)) : 0
};
